// extracted by mini-css-extract-plugin
export default {"container-input":"input-text_container-input__mPYuU","inline":"input-text_inline__W1jnO","input":"input-text_input__30POp","primary":"input-text_primary__5hQkm"};